<div class="row added-background">
  <div class="row first-element">
    <div class="col-2">
      <div i18n>ID:</div>
    </div>
    <div class="col-6">
      <p>{{ item.id }}</p>
    </div>
  </div>
  <div class="row">
    <div class="col-2">
      <div i18n>Version:</div>
    </div>
    <div class="col-6">
      <p>{{ item.version }}</p>
    </div>
  </div>
  <div class="row">
    <div class="col-2">
      <div i18n>Source:</div>
    </div>
    <div class="col-6">
      <p>{{ item.source }}</p>
    </div>
  </div>
  <div class="row">
    <div class="col-2">
      <div i18n>Note:</div>
    </div>
    <div class="col-6">
      <p>{{ item.note }}</p>
    </div>
  </div>
  <div class="row">
    <div class="col-2">
      <div i18n>Created by:</div>
    </div>
    <div class="col-6">
      <p>{{ item.created_by }}</p>
    </div>
  </div>
  <div class="row">
    <div class="col-2">
      <div i18n>Created on:</div>
    </div>
    <div class="col-6">
      <p>{{ utility.convertUnixTime_global(item.created_ts) }}</p>
    </div>
  </div>
</div>
